import React, { forwardRef, useEffect, useState } from "react";
import Checkbox from "../../../../generic/checkbox";
import InputField from "../../../../generic/inputField";
import TocDropdown from "../../../../generic/tocDropdown";
import { getArea, getFullAddress } from "../../../../service/generic/otherApi";
import {
  alphaNumExpWithSpace,
  integerExp,
  integerExpWithSpace,
} from "../../../../utils/regex";
import { areaErrorString, AREAOPTIONSTATUS, toCamelCase } from "./constant";
interface Type {
  id: number;
  name: string;
  fieldName: string;
}
export const Address = forwardRef((props: any, ref: any) => {
  const [type, setType] = useState<Type>(props.type);
  const [area, setArea] = useState<any>();
  const [areaOptions, setAreaOptions] = useState<any>([AREAOPTIONSTATUS]);
  const handelPincode = (value: any) => {
    if (value && value.length < 6) {
      setAreaOptions([AREAOPTIONSTATUS]);
      props.onChange(
        {
          address: { ...props.nominee.address, city: "", state: "" },
        },
        "pin"
      );
    }
  };
  async function getFullAddressDetails(pin: any, area: any) {
    try {
      if (pin && pin.length === 6 && area) {
        let payloadObj = { area: area, pinCode: pin };
        let fullAddress = await getFullAddress(payloadObj);
        if (fullAddress && fullAddress.data) {
          props.onChange(
            {
              address: {
                ...props.nominee.address,
                pin,
                city: toCamelCase(fullAddress.data.city.toLowerCase()),
                state: toCamelCase(fullAddress.data.state.toLowerCase()),
                country: toCamelCase(fullAddress.data.country.toLowerCase()),
              },
            },
            "pin"
          );
          props.setLoader(false);
        }
      } else {
        props.setLoader(false);
      }
    } catch (error) {}
  }
  async function getAreaDetails(pincode: any) {
    if (pincode && pincode.length === 6) {
      props.setLoader(true);
      try {
        let areaResp = await getArea(pincode);
        if (areaResp) {
          let areas = areaResp.data.areas;
          if (areas) {
            const list = areas.map((respObj: any) => {
              return {
                value: toCamelCase(respObj.toLowerCase()),
                display: toCamelCase(respObj.toLowerCase()),
              };
            });
            if (
              list &&
              list.length === 1 &&
              toCamelCase(list[0].value.toLowerCase()) ===
                toCamelCase(areaErrorString.toLowerCase())
            ) {
              props.setShowPincodeErrorModel(true);
              props.setNomineeErr({
                ...props.nomineeErr,
                address: {
                  ...props.nomineeErr.address,
                  pin: "Pincode is not valid",
                },
              });
              setAreaOptions([AREAOPTIONSTATUS]);
              props.setLoader(false);
            } else {
              console.log(props.nomineeErr);
              setAreaOptions(list);
              getFullAddressDetails(pincode, list[0].value);
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
  const addressErr = (error: any, type: string) => {
    let err = "";
    if (type === "pin") {
      if (error.value.length !== 6) err = "Pincode must be 6 digit.";
      else if (props.nomineeErr.address.pin) err = props.nomineeErr.address.pin;
    } else {
      if (error.required) err = "Address is required";
      // if (error.value.length > 0 && integerExp.test(error.value))
      //   err = "All the characters can't be Number.";
      if (error.value.length > 0 && integerExpWithSpace.test(error.value))
        err = "All the characters can't be Number.";
      // if (error.value.length > 0 && error.value.length < 5)
      //   err = "Minimum 5 characters are required.";
      if (!error.pattern)
        err = "Special characters are not allowed like < , > etc.";
    }

    props.setNomineeErr({
      ...props.nomineeErr,
      address: {
        ...props.nomineeErr.address,
        [type]: err,
      },
    });
  };
  useEffect(() => {
    if (props.areaOptions && props.areaOptions.length > 0) {
      setAreaOptions(props.areaOptions);
    }
  }, [props.areaOptions]);

  useEffect(() => {
    if (props.nominee.address.pin) {
      getAreaDetails(props.nominee.address.pin);
      handelPincode(props.nominee.address.pin);
    }
  }, []);
  return (
    <>
      {type && (
        <>
          <div className="custom--row nomineeAddr tradingAccnt">
            {/* <div className="custom-col-100 noLeftPAdding">
              <label className="input-label">{type.name} Address</label>
              <div>
                <textarea
                  rows={4}
                  cols={50}
                  placeholder="Enter Address of nominee"
                  onChange={(e) => props.onChange({ address: e.target.value })}
                  onMouseOut={(me) => {
                    me.currentTarget.blur();
                    props.handleChangeAddressErrors("address", me.target);
                  }}
                >
                  {props.nominee.address}
                </textarea>
                {props.nomineeErr.address ? (
                  <p className="error">{props.nomineeErr.address}</p>
                ) : (
                  ""
                )}
              </div>
              
            </div> */}
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">{type.name} Address Line 1</label>
              <InputField
                pattern={alphaNumExpWithSpace}
                required
                getValue
                onChange={(addr1) => {
                  props.onChange(
                    {
                      address: { ...props.nominee.address, addr1 },
                    },
                    "addr1"
                  );
                }}
                maxLength={30}
                onBlur={(error) => {
                  addressErr(error, "addr1");
                }}
                onMouseOut={() => {}}
                placeholder="Address Line 1"
                errorText={props.nomineeErr.address.addr1}
                defaultValue={props.nominee.address.addr1}
                autoComplete="off"
              ></InputField>
            </div>
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">{type.name} Address Line 2</label>
              <InputField
                pattern={alphaNumExpWithSpace}
                getValue
                onChange={(addr2) => {
                  props.onChange(
                    {
                      address: { ...props.nominee.address, addr2 },
                    },
                    "addr2"
                  );
                }}
                maxLength={30}
                onBlur={(error) => {
                  addressErr(error, "addr2");
                }}
                onMouseOut={() => {}}
                placeholder="Address Line 2"
                errorText={props.nomineeErr.address.addr2}
                defaultValue={props.nominee.address.addr2}
                autoComplete="off"
              ></InputField>
            </div>
          </div>
          <div className="custom--row nomineeAddr tradingAccnt">
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">{type.name} Address Line 3</label>
              <InputField
                pattern={alphaNumExpWithSpace}
                getValue
                onChange={(addr3) => {
                  props.onChange(
                    {
                      address: { ...props.nominee.address, addr3 },
                    },
                    "addr3"
                  );
                }}
                maxLength={30}
                onBlur={(error) => {
                  addressErr(error, "addr3");
                }}
                onMouseOut={() => {}}
                placeholder="Address Line 3"
                errorText={props.nomineeErr.address.addr3}
                defaultValue={props.nominee.address.addr3}
                autoComplete="off"
              ></InputField>
            </div>
            {props.dpType !== "CDSL" && (
              <div className="form-field custom-col noLeftPAdding">
                <label className="input-label">
                  {type.name} Address Line 4
                </label>
                <InputField
                  pattern={alphaNumExpWithSpace}
                  getValue
                  onChange={(addr4) => {
                    props.onChange(
                      {
                        address: { ...props.nominee.address, addr4 },
                      },
                      "addr4"
                    );
                  }}
                  maxLength={30}
                  onBlur={(error) => {
                    addressErr(error, "addr4");
                  }}
                  onMouseOut={() => {}}
                  placeholder="Address Line 4"
                  errorText={props.nomineeErr.address.addr4}
                  defaultValue={props.nominee.address.addr4}
                  autoComplete="off"
                ></InputField>
              </div>
            )}
          </div>
          <div className="custom--row nomineeArea tradingAccnt">
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">{type.name} Pincode</label>
              <InputField
                integer={true}
                required
                getValue
                onChange={(pin) => {
                  getAreaDetails(pin);
                  props.onChange(
                    {
                      address: { ...props.nominee.address, pin },
                    },
                    "pin"
                  );
                  handelPincode(pin);
                }}
                maxLength={6}
                onBlur={(error) => {
                  addressErr(error, "pin");
                }}
                onMouseOut={() => {}}
                placeholder="Enter PIN Code"
                errorText={props.nomineeErr.address.pin}
                defaultValue={props.nominee.address.pin}
                autoComplete="off"
              ></InputField>
            </div>
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">{type.name} Area</label>
              <TocDropdown
                selectedValue={area ? area : areaOptions[0].value}
                dropdownOptions={areaOptions ? areaOptions : []}
                onSelect={(val) => {
                  setArea(val);
                }}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="custom--row nomineeCityState tradingAccnt">
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">{type.name} City</label>
              <InputField
                disabled={true}
                integer={true}
                onChange={(city) =>
                  props.onChange({
                    address: { ...props.nominee.address, city },
                  })
                }
                onBlur={() => {}}
                onMouseOut={() => {}}
                placeholder="City"
                errorText={""}
                defaultValue={props.nominee.address.city}
              ></InputField>
            </div>
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">{type.name} State</label>
              <InputField
                integer={true}
                disabled={true}
                onChange={(state) =>
                  props.onChange({
                    address: { ...props.nominee.address, state },
                  })
                }
                onBlur={() => {}}
                onMouseOut={() => {}}
                placeholder="State"
                errorText={""}
                defaultValue={props.nominee.address.state}
              ></InputField>
            </div>
          </div>
        </>
      )}
    </>
  );
});
